module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "reports traccar_wrp"
  }, [(_vm.loadings) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader'), _vm._v(" "), _c('p', [_vm._v("Please Wait...")])], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "monitoring_wrp"
  }, [_c('div', {
    staticClass: "col-md-12 city_dropdown"
  }, [(!_vm.cityAdmin) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "city_rel_class c-pointer"
  }, [_c('multiselect', {
    attrs: {
      "deselect-label": "",
      "track-by": "value",
      "label": "name",
      "placeholder": "Select city",
      "options": _vm.cityList,
      "searchable": true,
      "allow-empty": false
    },
    on: {
      "select": _vm.onCitySelect
    },
    model: {
      value: (_vm.city),
      callback: function($$v) {
        _vm.city = $$v
      },
      expression: "city"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div'), _vm._v(" "), _c('button', {
    staticClass: "btn gradientbt",
    on: {
      "click": _vm.refreshReportList
    }
  }, [_vm._v("\n                Refresh\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12",
    staticStyle: {
      "padding": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "dates_left_wrp"
  }, [_c('div', {
    staticClass: "dates_left"
  }, [_c('label', [_vm._v("Zone")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "id": "startDate",
      "lang": "en",
      "name": "startDate",
      "not-after": _vm.disabledStartDate,
      "clearable": false,
      "required": "",
      "input-class": "form-control",
      "width": "100%",
      "valueType": "format",
      "format": 'DD-MM-YYYY',
      "placeholder": "Date Filter"
    },
    on: {
      "input": _vm.startDate
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('v-server-table', {
    ref: "traccarMonitoringZoneTable",
    attrs: {
      "url": "",
      "limit": 5,
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.onRowClick,
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "percentage",
      fn: function(props) {
        return [_c('progress', {
          staticClass: "progressContainer",
          attrs: {
            "max": "100"
          },
          domProps: {
            "value": props.row.percentage
          }
        }), _vm._v(" "), _c('p', {
          staticClass: "progressReference"
        }, [_vm._v(_vm._s(props.row.percentage) + " % ")])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "9"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 media_padding"
  }, [_c('div', {
    staticClass: "map-view"
  }, [_c('traccarMonitoringMap', {
    key: _vm.refreshKey
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 col-sm-12"
  }, [_c('div', {
    staticClass: "trip_details route_tracking_trip_details"
  }, [_c('div', {
    staticClass: "shedule_date_data"
  }, [_c('label', [_vm._v("Trip Details ")]), _vm._v(" "), _c('div', {
    staticClass: "zone_cart_wrp"
  }, [_c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Zone")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.zoneName ? _vm.details.zoneName : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Vehicle No")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.vehicleId ? _vm.details.vehicleId.vNumber : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Device Status")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.deviceStatus != undefined ? _vm.deviceStatus.status : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip Status")]), _vm._v(" "), _c('p', {
    class: _vm.details.tripStatus
  }, [_vm._v(_vm._s(_vm.details.tripStatus ? _vm.details.tripStatus : "--"))])])]), _vm._v(" "), _c('div', {
    staticClass: "zone_cart_wrp"
  }, [_c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip Start Time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.startTime ? _vm.details.startTime : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Trip End Time")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.endTime ? _vm.details.endTime : "--"))])])]), _vm._v(" "), _c('div', {
    staticClass: "zone_cart_wrp driver_zone_wrp"
  }, [_c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Driver Name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.driverFirstName ? _vm.details.driverFirstName + ' ' + _vm.details.driverLastName :
    "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Driver Contact Number")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.driverContactName ? _vm.details.driverContactName : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Helper Name")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.helperFirstName ? _vm.details.helperFirstName + ' ' + _vm.details.helperLastName :
    "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Helper Contact Number")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.helperContactName ? _vm.details.helperContactName : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Lines")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.totalLines != null ? _vm.details.totalLines : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Completed Lines")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.completedLines != null ? _vm.details.completedLines : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Skipped Lines")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.totalLines != null ? _vm.details.totalLines - _vm.details.completedLines : "--") + "\n                                ")])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Covered Distance [In Zone]")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.tracarrDistInZone != null ? _vm.details.tracarrDistInZone : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Covered Distance")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.tracarrDistance != null ? _vm.details.tracarrDistance : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Time(Hrs)")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.tracarrTime != null ? _vm.details.tracarrTime : "--"))])]), _vm._v(" "), _c('div', {
    staticClass: "shedule_date_inner"
  }, [_c('h5', [_vm._v("Total Time [In Zone]")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.details.TracarrTimeInZone != null ? _vm.details.TracarrTimeInZone : "--"))])])])])])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-d195fd66", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d195fd66"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/location-tracking/traccarMonitoring.vue
// module id = 2386
// module chunks = 0